import { CloseOutlined } from '@ant-design/icons';
import { Button, Input, Typography } from 'antd';
import { useEffect, useState } from 'react';

const { Text } = Typography;

export default function DiscussionPoll({
  onClose,
  pollItems,
  setPollItems,
  error,
  setError,
  setLengthError,
}) {
  const [foundIndex, setFoundIndex] = useState(null);
  const handleAddPollItem = () => {
    const newPollItems = [...pollItems, ''];
    setPollItems(newPollItems);
  };

  const handleDeletePollItem = (index) => {
    const newPollItems = [...pollItems];
    newPollItems.splice(index, 1);
    setPollItems(newPollItems);
  };

  useEffect(() => {
    return () => {
      setLengthError(false);
    };
  }, []);

  const handlePollItemChange = (index, value) => {
    const newPollItems = [...pollItems];
    newPollItems[index] = value;
    setPollItems(newPollItems);
  };

  return (
    <div className="mb-4 pr-2" style={{ overflowY: 'auto', maxHeight: '200px' }}>
      <div className="border px-2 py-2" style={{ borderRadius: '8px' }}>
        <div className="d-flex align-items-center justify-content-between">
          <Text className=" font-size-sm font-weight-bold pl-1">Add Poll</Text>
          <CloseOutlined
            rev=""
            onClick={() => {
              onClose();
              setPollItems(['', '', '']);
            }}
            className="hover-icon-bg p-2"
          />
        </div>
        <div className="px-2">
          {pollItems.map((item, index) => (
            <div key={index} className="d-flex align-items-center my-3 gap-2">
              <div className="d-flex flex-column w-100">
                <Input
                  value={item}
                  onChange={(e) => {
                    setFoundIndex(null);
                    setError(false);
                    setLengthError(false);
                    const isRepeat = pollItems.filter(
                      (el) => el === e.target.value && el !== ''
                    );
                    isRepeat?.length && setError(true);
                    setFoundIndex(index);
                    const pollDatas = pollItems?.filter((el) => {
                      if (el !== '') return el;
                    });
                    pollDatas?.length < 1 && setLengthError(true);
                    handlePollItemChange(index, e.target.value);
                  }}
                  placeholder={`Option ${index + 1}`}
                  style={{ flex: 1, marginRight: '8px', borderRadius: '8px' }}
                  className="p-3"
                />
                {error && foundIndex === index && (
                  <span
                    className="text-danger w-100 mt-1"
                    style={{ textAlign: 'left' }}
                  >
                    This is already an option.
                  </span>
                )}
              </div>
              <CloseOutlined
                rev=""
                className="hover-icon-bg p-2"
                onClick={() => handleDeletePollItem(index)}
                style={{ fontSize: '12px' }}
              />
              {/* <Button
            // type="danger"
            onClick={() => handleDeletePollItem(index)}
            icon={<i className="fas fa-trash"></i>}
          /> */}
            </div>
          ))}
        </div>
        <div className="mx-2">
          <Button
            onClick={handleAddPollItem}
            className="mt-2 h-100 py-2 bg-light w-100 button-hover-border border-0 "
            style={{ borderRadius: '8px' }}
          >
            <i className="fas fa-plus mr-2"></i>
            Add Poll Option
          </Button>
        </div>
      </div>
    </div>
  );
}
